import { Tabs } from "antd";
import { Content } from "antd/es/layout/layout";
import Footer from "components/Footer/Footer";
import { routes } from "config/routes";
import React, { useEffect, useRef } from "react";
import useCoreStore from "views/hooks/useCoreStore";
import useFooterStore from "views/hooks/useFooterStore";
import useGeneralTabs from "./hooks/useGeneralTabs";

export default function General(): React.ReactElement {
  const companySelected = useCoreStore(state => state.companySelected);
  const setHandleOkSaveButton = useFooterStore(state => state.setHandleOkSaveButton);
  const contentRef = useRef<HTMLDivElement>(null);

  const TABS_OPTIONS = useGeneralTabs();

  const pathSegments = window.location.pathname.split("/");
  const activeTabKey = pathSegments[pathSegments.length - 1];

  const handleOnChange = (key: string) => {
    setHandleOkSaveButton(false);

    routes.navigate(`/company/${companySelected?.id}/settings/general/${key}`);
  };

  useEffect(() => {
    const contentElement = contentRef.current;
    if (!contentElement) return;

    const handleScroll = () => {
      const scrollTop = contentElement.scrollTop;
      const tabsNav = document.querySelector(".ant-tabs-nav");
      if (tabsNav) {
        if (scrollTop > 12) {
          tabsNav.classList.add("scrolled");
        } else {
          tabsNav.classList.remove("scrolled");
        }
      }
    };

    contentElement.addEventListener("scroll", handleScroll);

    return () => {
      contentElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Content className="layout-card-content__with-tabs" ref={contentRef}>
        <Tabs
          className="antd-newrai-tabs"
          defaultActiveKey={activeTabKey}
          items={TABS_OPTIONS}
          onChange={handleOnChange}
        />
      </Content>
      <Footer />
    </>
  );
}
